var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-px-8 tw-py-4 tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-350",attrs:{"data-cy":"panel-header"}},[_vm._t("default"),_c('CloseButton',{on:{"click":function($event){return _vm.$emit('close-panel')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }